<template>
  <div class="product-template">
    <div class="list-card" v-if="viewMode === 'list'">
      <div class="list-title">商品模板</div>
      <div class="list-toolbar">
        <Input class="search-input" v-model="keywords" placeholder="模板名称/商品分类/商品名称" clearable @on-enter="searchTemplate"></Input>
        <Button type="error" @click="searchTemplate">搜索</Button>
        <Button type="error" ghost @click="openCreate">+新增商品模板</Button>
      </div>
      <Table
        border
        :columns="columns"
        :data="pagedTemplateList">
      </Table>
      <div class="page-row">
        <span>共 {{templateTotal}} 条</span>
        <Page
          :total="templateTotal"
          :current="currentPage"
          :page-size="pageSize"
          size="small"
          @on-change="changePage"
          @on-page-size-change="changePageSize">
        </Page>
      </div>
    </div>

    <div v-if="viewMode === 'edit'">
      <div class="back-row">
        <Button @click="backList">返回模板列表</Button>
      </div>
      <div class="section">
      <div class="section-title">服务类目</div>
      <div class="category-panel">
        <div
          class="category-card"
          :class="{active: activeClassId == item.id}"
          v-for="item in categoryList"
          :key="item.id"
          @click="changeCategory(item)">
          <Avatar :src="item.img" icon="ios-person" size="large" />
          <div class="category-name">{{item.name}}</div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-title">服务类型</div>
      <div class="white-panel">
        <tabNav :list="serviceList" v-model="form.type_id"></tabNav>
      </div>
    </div>

    <div class="section">
      <div class="section-title">下单模式</div>
      <div class="white-panel">
        <tabNav :list="modeList" v-model="form.order_type"></tabNav>
      </div>
    </div>

    <div class="section">
      <div class="editor-card">
        <div class="editor-header">
          <div>
            <span class="text-theme">商品模板</span>
            <span class="muted"> / 编辑商品模板</span>
          </div>
        </div>

        <Form class="template-form" :label-width="100" label-position="left">
          <FormItem label="模板名称:" required>
            <Input class="template-input" v-model="form.template_name" :maxlength="100" placeholder="请输入模板名称"></Input>
          </FormItem>

          <div class="goods-group" v-for="(goods, index) in form.goods" :key="goods.key">
            <FormItem label="商品名称:" required>
              <div class="inline-row">
                <Select class="template-input" v-model="goods.product_first_class_id" placeholder="请选择" @on-change="changeFirstClass(goods)">
                  <Option :value="item.id" v-for="item in allClass" :key="item.id">{{item.name}}</Option>
                </Select>
                <Select class="template-input" v-model="goods.product_class_id" placeholder="请选择" @on-change="changeProductClass(goods)">
                  <Option :value="item.id" v-for="item in goods.classTwo" :key="item.id">{{item.name}}</Option>
                </Select>
                <InputNumber :min="1" :max="999" v-model="goods.number"></InputNumber>
                <div class="price" v-if="getSubmitOrderType() === 2">(参考价格：{{goods.reference || 0}})</div>
              </div>
            </FormItem>

            <FormItem class="media-form-item" label="商品图片/视频:" required>
              <div class="upload-row paste-upload-area" tabindex="0" @paste="handleTemplateGoodsPaste($event, index)">
                <Upload :ref="`templateImageUpload${index}`" :max="5" :more.sync="imgMore" :imgList.sync="goods.product_img"></Upload>
                <Upload
                  :ref="`templateVideoUpload${index}`"
                  class="video-upload"
                  type="video"
                  accept="video/mp4, video/avi, video/mov, video/quicktime, video/x-msvideo"
                  :format="['mp4', 'avi', 'mov']"
                  :max-size="51200"
                  :img.sync="goods.product_video">
                  <div slot="upload" class="video-upload-slot">
                    <Icon type="logo-youtube" size="20"></Icon>
                    <div>上传视频</div>
                  </div>
                </Upload>
              </div>
              <div class="tips">上传清晰商品图片或视频，最多上传5张图片，视频大小不超过50M</div>
            </FormItem>

            <FormItem label="商品备注:">
              <Input
                class="remark-input"
                type="textarea"
                maxlength="400"
                :rows="5"
                v-model="goods.special"
                placeholder="请输入商品备注、安装要求或特殊说明">
              </Input>
              <div class="count">{{(goods.special || '').length}}/400</div>
            </FormItem>
          </div>

          <div class="footer-actions">
            <Button type="primary" class="save-btn" :loading="savingTemplate" :disabled="savingTemplate" @click="saveTemplate">保存模板</Button>
          </div>
        </Form>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import tabNav from '../../../components/tabNav'
import Upload from '../../../components/upload'

const PRODUCT_TEMPLATE_LIST_API = '690000000010'
const PRODUCT_TEMPLATE_ADD_API = '690000000011'
const PRODUCT_TEMPLATE_DETAIL_API = '690000000012'
const PRODUCT_TEMPLATE_UPDATE_API = '690000000013'
const PRODUCT_TEMPLATE_DELETE_API = '690000000014'
const PRODUCT_TEMPLATE_DEFAULT_API = '690000000015'

export default {
  name: 'productTemplate',
  components: {
    tabNav,
    Upload
  },
  data () {
    return {
      loading: false,
      savingTemplate: false,
      imgMore: true,
      viewMode: 'list',
      keywords: '',
      currentPage: 1,
      pageSize: 10,
      templateTotal: 0,
      activeClassId: '',
      categoryList: [],
      serviceList: [],
      modeList: [],
      allClass: [],
      templateList: [],
      defaultingTemplateId: '',
      selectedTemplate: null,
      columns: [
        {
          title: '序号',
          key: 'index',
          width: 70,
          align: 'center',
          render: (h, params) => {
            return h('span', (this.currentPage - 1) * this.pageSize + params.index + 1)
          }
        },
        {
          title: '模板名称',
          key: 'template_name',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', this.getTemplateName(params.row))
          }
        },
        {
          title: '商品分类',
          key: 'category_name',
          align: 'center',
          minWidth: 120,
          render: (h, params) => {
            return h('span', this.getCategoryName(params.row.class_id || this.activeClassId))
          }
        },
        {
          title: '商品名称',
          key: 'product_class',
          align: 'center',
          minWidth: 180,
          render: (h, params) => {
            return h('span', params.row.product_class || params.row.product_model || '-')
          }
        },
        {
          title: '商品备注',
          key: 'special',
          align: 'center',
          minWidth: 220,
          render: (h, params) => {
            return h('span', {
              attrs: {
                title: params.row.special || ''
              }
            }, this.getShortText(params.row.special))
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'center',
          width: 180,
          render: (h, params) => {
            const isDefault = Number(params.row.is_default) === 1
            return h('div', [
              h('span', {
                class: 'table-action danger',
                on: {
                  click: () => this.openEdit(params.row)
                }
              }, '编辑'),
              h('span', {
                class: 'table-action',
                on: {
                  click: () => this.deleteTemplate(params.row)
                }
              }, '删除'),
              h('span', {
                class: {
                  'table-action': true,
                  'is-default': isDefault
                },
                on: {
                  click: event => {
                    event.stopPropagation()
                    this.setDefaultTemplate(params.row)
                  }
                }
              }, isDefault ? '已默认' : '设默认')
            ])
          }
        }
      ],
      form: this.getEmptyForm()
    }
  },
  created () {
    this.getCategoryList()
    this.$eventBus && this.$eventBus.$on('main-menu-select', this.handleMainMenuSelect)
  },
  beforeDestroy () {
    this.$eventBus && this.$eventBus.$off('main-menu-select', this.handleMainMenuSelect)
  },
  activated () {
    this.refreshTemplateList()
  },
  beforeRouteUpdate (to, from, next) {
    if (to.name === 'product_template') {
      this.backList()
    }
    next()
  },
  computed: {
    filteredTemplateList () {
      return this.templateList
    },
    pagedTemplateList () {
      return this.templateList
    }
  },
  methods: {
    getEmptyGoods () {
      return {
        key: Date.now() + Math.random(),
        product_first_class_id: '',
        product_class_id: '',
        classTwo: [],
        number: 1,
        product_img: [],
        product_video: '',
        environment_img: [],
        product_affiliated: [],
        product_model: '',
        is_remove: 2,
        product_size: '',
        install_img: [],
        reference: 0,
        special: ''
      }
    },
    getEmptyForm () {
      return {
        template_name: '',
        class_id: '',
        type_id: '',
        order_type: '',
        goods: [this.getEmptyGoods()]
      }
    },
    getCategoryList () {
      this.$request('611b5e915c69e', {}).then(res => {
        this.categoryList = (res.data.data.list || []).map(item => ({
          id: item.id,
          img: item.thumbnail,
          name: item.name,
          show_service_type: item.show_service_type || [],
          pay_type: item.pay_type || []
        }))
        if (this.categoryList.length) {
          this.changeCategory(this.categoryList[0])
        }
      })
    },
    changeCategory (item) {
      this.activeClassId = item.id
      this.form.class_id = item.id
      this.serviceList = item.show_service_type.map(type => ({
        value: type.id,
        label: type.name
      }))
      this.modeList = item.pay_type.map(type => ({
        value: type.id,
        label: type.name
      }))
      this.form.type_id = this.serviceList[0] ? this.serviceList[0].value : ''
      this.form.order_type = this.modeList[0] ? this.modeList[0].value : ''
      this.getGoodsClass()
    },
    getGoodsClass () {
      return this.$request('6142ac6031e35', {
        class_id: this.activeClassId
      }).then(res => {
        this.allClass = res.data.data || []
      })
    },
    getTemplateList () {
      this.loading = true
      this.$request(PRODUCT_TEMPLATE_LIST_API, {
        size: this.pageSize,
        page: this.currentPage,
        class_id: this.viewMode === 'list' ? 0 : (this.activeClassId || 0),
        keywords: this.keywords || ''
      }, 'post').then(res => {
        const data = res.data.data || []
        const list = data.list || data.data || data
        this.templateList = (Array.isArray(list) ? list : []).map(this.normalizeTemplate)
        this.templateTotal = data.total || data.count || data.total_count || this.templateList.length
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    refreshTemplateList () {
      this.getTemplateList()
      if (!this.categoryList.length) {
        this.getCategoryList()
      }
    },
    normalizeTemplate (item, index) {
      const templateId = this.getTemplateId(item)
      const orderType = this.getTemplateOrderType(item)
      return Object.assign({}, item, {
        id: templateId,
        order_type: orderType,
        is_default: Number(item.is_default) === 1 ? 1 : 0,
        __key: templateId || `${this.activeClassId}-${index}`
      })
    },
    getTemplateOrderType (item) {
      return item.order_type || item.pay_type_id || item.pay_type || item.order_mode || ''
    },
    getTemplateId (item) {
      return item.id || item.template_id || item.product_template_id || ''
    },
    getTemplateName (item) {
      return item.template_name || item.product_class || item.product_model || '未命名模板'
    },
    getCategoryName (id) {
      const category = this.categoryList.find(item => item.id == id)
      return category ? category.name : '-'
    },
    getShortText (text) {
      const value = text || ''
      return value.length > 16 ? value.slice(0, 16) + '...' : value
    },
    searchTemplate () {
      this.currentPage = 1
      this.getTemplateList()
    },
    changePage (page) {
      this.currentPage = page
      this.getTemplateList()
    },
    changePageSize (size) {
      this.pageSize = size
      this.currentPage = 1
      this.getTemplateList()
    },
    handleMainMenuSelect (name) {
      if (name === 'product_template') {
        this.backList()
      }
    },
    openCreate () {
      this.newTemplate()
      this.viewMode = 'edit'
    },
    openEdit (item) {
      this.selectTemplate(item, true)
      this.viewMode = 'edit'
    },
    backList (refresh = true) {
      this.viewMode = 'list'
      if (refresh) {
        this.getTemplateList()
      }
    },
    selectTemplate (item, needDetail) {
      if (needDetail) {
        return this.getTemplateDetail(item)
      }
      this.selectedTemplate = item
      return this.prepareTemplateCategory(item).then(() => {
        const goods = this.templateToGoods(item)
        this.form = {
          template_name: item.template_name || item.product_class || item.product_model || '',
          class_id: item.class_id || this.activeClassId,
          type_id: item.type_id || this.form.type_id,
          order_type: this.getTemplateOrderType(item),
          goods: [goods]
        }
      })
    },
    getTemplateDetail (item) {
      const templateId = this.getTemplateId(item)
      if (!templateId) {
        this.selectTemplate(item)
        return
      }
      this.loading = true
      this.$request(PRODUCT_TEMPLATE_DETAIL_API, {
        id: templateId,
        template_id: templateId
      }, 'post').then(res => {
        const detail = this.getTemplateDetailData(res.data.data || item)
        return this.selectTemplate(this.normalizeTemplate(Object.assign({}, item, detail), 0)).then(() => {
          this.loading = false
        })
      }).catch(() => {
        this.selectTemplate(item).then(() => {
          this.loading = false
        })
      })
    },
    getTemplateDetailData (data) {
      const detail = Array.isArray(data) ? (data[0] || {}) : data
      const goodsList = detail.goods || detail.list || detail.data || []
      const goods = Array.isArray(goodsList) ? (goodsList[0] || {}) : goodsList
      return Object.assign({}, detail, goods)
    },
    prepareTemplateCategory (item) {
      const classId = item.class_id || this.activeClassId
      const category = this.categoryList.find(category => category.id == classId)
      if (category) {
        this.activeClassId = category.id
        this.serviceList = category.show_service_type.map(type => ({
          value: type.id,
          label: type.name
        }))
        this.modeList = category.pay_type.map(type => ({
          value: type.id,
          label: type.name
        }))
      } else {
        this.activeClassId = classId
      }
      return this.getGoodsClass()
    },
    templateToGoods (item) {
      const goods = this.getEmptyGoods()
      goods.product_first_class_id = item.product_first_class_id || ''
      goods.product_class_id = item.product_class_id || ''
      goods.number = item.number || 1
      goods.product_img = this.normalizeMediaList(item.product_img || item.product_imgs || item.product_image || item.img || item.images)
      goods.product_video = this.normalizeMediaUrl(item.product_video || item.video || item.product_video_url || item.video_url)
      goods.environment_img = this.normalizeMediaList(item.environment_img || item.environment_imgs)
      goods.product_affiliated = this.normalizeArrayField(item.product_affiliated)
      goods.product_model = item.product_model || ''
      goods.is_remove = item.is_remove === '' || item.is_remove === undefined || item.is_remove === null ? 2 : item.is_remove
      goods.product_size = item.product_size || ''
      goods.install_img = this.normalizeMediaList(item.install_img || item.install_imgs)
      goods.reference = item.reference || item.recommend_price || item.product_price || 0
      goods.special = item.special || ''
      this.changeFirstClass(goods)
      return goods
    },
    normalizeArrayField (value) {
      if (!value) return []
      if (Array.isArray(value)) return value
      if (typeof value === 'string') {
        const text = value.trim()
        if (!text) return []
        try {
          const parsed = JSON.parse(text)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return []
    },
    normalizeMediaList (value) {
      if (!value) return []
      let list = value
      if (typeof value === 'string') {
        const text = value.trim()
        if (!text) return []
        try {
          list = JSON.parse(text)
        } catch (e) {
          list = text.split(',')
        }
      }
      if (!Array.isArray(list)) {
        list = [list]
      }
      return list.map(item => this.normalizeMediaUrl(item)).filter(item => item)
    },
    normalizeMediaUrl (value) {
      if (!value) return ''
      if (typeof value === 'string') return value
      return value.url || value.path || value.fileUrl || value.src || ''
    },
    changeFirstClass (goods) {
      const selected = this.allClass.find(item => item.id == goods.product_first_class_id)
      goods.classTwo = selected && selected.childens ? selected.childens : []
      if (!goods.classTwo.some(item => item.id == goods.product_class_id)) {
        goods.product_class_id = goods.classTwo[0] ? goods.classTwo[0].id : ''
      }
      this.changeProductClass(goods)
    },
    changeProductClass (goods) {
      const selected = goods.classTwo.find(item => item.id == goods.product_class_id) || {}
      goods.reference = selected.reference || selected.recommend_price || selected.product_price || goods.reference || 0
    },
    newTemplate () {
      this.selectedTemplate = null
      this.form = this.getEmptyForm()
      this.form.class_id = this.activeClassId
      this.form.type_id = this.serviceList[0] ? this.serviceList[0].value : ''
      this.form.order_type = this.modeList[0] ? this.modeList[0].value : ''
    },
    handleTemplateGoodsPaste (e, index) {
      const videoFile = this.getPastedFile(e, 'video')
      if (videoFile) {
        e.preventDefault()
        return this.uploadPastedTemplateVideo(videoFile, index)
      }

      const imageFile = this.getPastedFile(e, 'image')
      if (!imageFile) return
      e.preventDefault()
      this.uploadPastedTemplateImage(imageFile, index)
    },
    getPastedFile (e, fileType) {
      const clipboardData = e.clipboardData || window.clipboardData
      if (!clipboardData) return null

      const files = clipboardData.files ? Array.from(clipboardData.files) : []
      const pastedFile = files.find(file => this.isPasteFileType(file, fileType))
      if (pastedFile) return pastedFile

      const items = clipboardData.items ? Array.from(clipboardData.items) : []
      const pastedItem = items.find(item => this.isPasteFileType(item, fileType))
      if (!pastedItem) return null

      const file = pastedItem.getAsFile()
      if (!file) return null
      return this.renamePastedFile(file, fileType)
    },
    isPasteFileType (file, fileType) {
      const type = file.type || ''
      if (type.indexOf(`${fileType}/`) === 0) return true
      if (!file.name) return false
      if (fileType === 'video') return /\.(mp4|avi|mov)$/i.test(file.name)
      return /\.(jpg|jpeg|png|gif|webp)$/i.test(file.name)
    },
    renamePastedFile (file, fileType) {
      const type = file.type || ''
      const extMap = {
        'image/jpeg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'video/mp4': 'mp4',
        'video/quicktime': 'mov',
        'video/x-msvideo': 'avi'
      }
      const ext = extMap[type] || (file.name && file.name.split('.').pop()) || (fileType === 'video' ? 'mp4' : 'png')
      return new File([file], `paste-${Date.now()}.${ext}`, { type: file.type })
    },
    getUploadRef (name) {
      const uploadRef = this.$refs[name]
      return Array.isArray(uploadRef) ? uploadRef[0] : uploadRef
    },
    uploadPastedTemplateImage (file, index) {
      const goods = this.form.goods[index]
      if (!goods) return
      if (!Array.isArray(goods.product_img)) {
        this.$set(goods, 'product_img', [])
      }
      if (goods.product_img.length > 5) {
        this.$set(goods, 'product_img', goods.product_img.slice(0, 5))
      }
      if (goods.product_img.length >= 5) {
        return this.$message.error('最多上传5张商品图片')
      }
      const imageFile = this.renamePastedFile(file, 'image')
      const uploadRef = this.getUploadRef(`templateImageUpload${index}`)
      uploadRef && uploadRef.uploadByFile(imageFile)
    },
    uploadPastedTemplateVideo (file, index) {
      const videoFile = this.renamePastedFile(file, 'video')
      if (!/\.(mp4|avi|mov)$/i.test(videoFile.name)) {
        return this.$message.error('请上传mp4、avi或mov格式的视频')
      }
      if (videoFile.size > 50 * 1024 * 1024) {
        return this.$message.error('视频大小不能超过50M')
      }
      const uploadRef = this.getUploadRef(`templateVideoUpload${index}`)
      uploadRef && uploadRef.uploadByFile(videoFile)
    },
    getSubmitOrderType () {
      const rawType = this.form.order_type
      const rawNumber = Number(rawType)
      if (rawNumber === 1 || rawNumber === 2) return rawNumber

      const selectedMode = this.modeList.find(item => item.value == rawType)
      const label = selectedMode ? selectedMode.label || '' : ''
      if (label.indexOf('\u4e00\u53e3\u4ef7') > -1) return 2
      if (label.indexOf('\u62a5\u4ef7') > -1 || label.indexOf('\u62db\u6807') > -1) return 1

      return ''
    },
    saveTemplate () {
      if (this.savingTemplate) return
      const templateName = String(this.form.template_name || '').trim()
      if (!templateName) {
        return this.$message.error('请输入模板名称')
      }
      if (templateName.length > 100) {
        return this.$message.error('模板名称不能超过100个字符')
      }
      this.form.template_name = templateName
      if (!this.form.class_id) {
        return this.$message.error('请选择服务类目')
      }
      if (!this.form.type_id) {
        return this.$message.error('请选择服务类型')
      }
      if (!this.getSubmitOrderType()) {
        return this.$message.error('\u8bf7\u9009\u62e9\u4e0b\u5355\u6a21\u5f0f')
      }
      if (!this.form.goods[0].product_first_class_id || !this.form.goods[0].product_class_id) {
        return this.$message.error('请选择商品名称')
      }
      const isEdit = !!this.selectedTemplate
      if (isEdit && !this.getTemplateId(this.selectedTemplate)) {
        return this.$message.error('缺少模板ID，无法修改')
      }
      this.savingTemplate = true
      this.$request(isEdit ? PRODUCT_TEMPLATE_UPDATE_API : PRODUCT_TEMPLATE_ADD_API, this.buildTemplatePayload(), 'post').then(() => {
        this.$message.success(isEdit ? '修改成功' : '新增成功')
        this.backList()
        this.savingTemplate = false
      }).catch(() => {
        this.savingTemplate = false
      })
    },
    buildTemplatePayload () {
      const goods = this.form.goods[0]
      const templateId = this.selectedTemplate ? this.getTemplateId(this.selectedTemplate) : ''
      const orderType = this.getSubmitOrderType()
      const payload = {
        template_name: String(this.form.template_name || '').trim(),
        class_id: Number(this.form.class_id),
        type_id: Number(this.form.type_id),
        order_type: orderType,
        product_first_class_id: Number(goods.product_first_class_id || 0),
        product_class_id: Number(goods.product_class_id),
        number: Number(goods.number || 1),
        product_img: this.normalizeMediaList(goods.product_img).slice(0, 5),
        environment_img: this.normalizeMediaList(goods.environment_img),
        product_affiliated: this.normalizeArrayField(goods.product_affiliated),
        product_model: String(goods.product_model || ''),
        is_remove: Number(goods.is_remove === '' || goods.is_remove === undefined || goods.is_remove === null ? 2 : goods.is_remove),
        product_size: goods.product_size || '',
        install_img: this.normalizeMediaList(goods.install_img),
        product_video: this.normalizeMediaUrl(goods.product_video),
        special: String(goods.special || ''),
        product_maintain_id: Number(goods.product_maintain_id || 0),
        product_maintain: String(goods.product_maintain || ''),
        reference: Number(goods.reference || 0),
        is_default: 0
      }
      if (templateId) {
        payload.id = Number(templateId)
      }
      return payload
    },
    deleteTemplate (row) {
      const target = row || this.selectedTemplate
      if (!target) return
      this.$confirm('确定删除当前商品模板吗？', '删除提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const templateId = this.getTemplateId(target)
        if (!templateId) {
          return this.$message.error('缺少模板ID，无法删除')
        }
        this.$request(PRODUCT_TEMPLATE_DELETE_API, {
          id: templateId
        }, 'post').then(() => {
          this.$message.success('删除成功')
          this.newTemplate()
          this.viewMode = 'list'
          this.getTemplateList()
        })
      }).catch(() => {})
    },
    setDefaultTemplate (row) {
      const templateId = this.getTemplateId(row)
      if (!templateId) return
      if (Number(row.is_default) === 1) return
      if (this.defaultingTemplateId) return
      this.defaultingTemplateId = templateId
      this.$request(PRODUCT_TEMPLATE_DEFAULT_API, {
        id: templateId
      }, 'post').then(() => {
        this.$message.success('设置默认模板成功')
        this.templateList = this.templateList.map(item => {
          const itemId = this.getTemplateId(item)
          return Object.assign({}, item, {
            is_default: itemId == templateId ? 1 : 0
          })
        })
        this.getTemplateList()
      }).finally(() => {
        this.defaultingTemplateId = ''
      })
    }
  }
}
</script>

<style scoped lang="less">
  .product-template {
    padding: 10px;
    background-color: #f5f7f9;

    .list-card {
      background-color: #fff;
      border: 1px solid #dddddd;
      border-radius: 3px;
    }

    .list-title {
      padding: 14px 20px;
      border-bottom: 1px solid #dddddd;
      font-size: 16px;
      color: #111;
    }

    .list-toolbar {
      display: flex;
      align-items: center;
      padding: 16px 20px;
      gap: 10px;
    }

    .search-input {
      width: 410px;
    }

    .page-row {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
      padding: 16px 20px;
    }

    /deep/.ivu-page-options {
      display: none;
    }

    /deep/.table-action {
      cursor: pointer;
      margin: 0 6px;
      color: #333;
    }

    /deep/.table-action.danger {
      color: #e60012;
    }

    /deep/.table-action.is-default {
      cursor: default;
      color: #ff9d2e;
    }

    .back-row {
      margin-bottom: 12px;
    }

    .section {
      margin-bottom: 24px;
    }

    .section-title {
      font-size: 18px;
      font-weight: 600;
      color: #111;
      margin-bottom: 14px;
    }

    .category-panel,
    .white-panel,
    .editor-card {
      background-color: #fff;
      border-radius: 3px;
    }

    .category-panel {
      display: flex;
      align-items: center;
      padding: 30px;
      min-height: 130px;
    }

    .category-card {
      width: 112px;
      height: 112px;
      margin-right: 28px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;
      color: #111;
    }

    .category-card.active {
      background-color: #ff9d2e;
      color: #fff;
    }

    .category-name {
      margin-top: 10px;
    }

    .white-panel {
      padding: 30px;
    }

    .editor-card {
      border: 1px solid #eeeeee;
      overflow: hidden;
    }

    .editor-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 18px 20px;
      border-bottom: 1px solid #eeeeee;
      font-size: 16px;
    }

    .template-form {
      padding: 20px 20px 0;
    }

    .template-input {
      width: 360px;
      margin-right: 14px;
    }

    /deep/.media-form-item .ivu-form-item-label {
      width: 124px !important;
      white-space: nowrap;
      line-height: 60px;
      padding: 0 24px 0 0;
    }

    /deep/.media-form-item .ivu-form-item-content {
      margin-left: 124px !important;
    }

    .inline-row,
    .upload-row {
      display: flex;
      align-items: center;
    }

    .price {
      color: red;
      margin-left: 20px;
      white-space: nowrap;
    }

    .goods-group {
      position: relative;
      padding: 20px 0 8px;
      border-top: 1px solid #eeeeee;
    }

    .goods-group:first-of-type {
      border-top: none;
    }

    .video-upload {
      margin-left: 12px;
    }

    .video-upload-slot {
      width: 58px;
      height: 58px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #666;
      font-size: 12px;
    }

    .tips {
      color: #666;
      font-size: 12px;
      margin-top: 8px;
    }

    .remark-input {
      width: 550px;
    }

    .count {
      width: 550px;
      text-align: right;
      color: #999;
      margin-top: -22px;
      padding-right: 8px;
      position: relative;
      z-index: 1;
    }

    .footer-actions {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding: 20px 0;
      border-top: 1px solid #eeeeee;
    }

    .save-btn {
      width: 120px;
      background-color: #e60012;
      border-color: #e60012;
    }

    .text-theme {
      color: #e60012;
    }

    .muted {
      color: #333;
    }
  }
</style>
